// src/modules/app-views/_apps/appmulti/coupons/service.js
// *******************************************************************************
// HELPER FUNCTIONS FOR COUPONS MODULE
// *******************************************************************************

// Discount type options (D7 reconcile: 'percentage', NOT 'percentagem')
function getDiscountTypes() {
  return [
    { label: 'percentage', value: 'percentage' },
    { label: 'value', value: 'value' },
  ];
}

// Derived display status (no stored status field — computed from dates + usage)
function getDerivedStatus(record) {
  if (!record) return 'active';
  const now = Date.now();
  if (record.startDate && now < new Date(record.startDate).getTime()) return 'scheduled';
  if (record.expirationDate && now > new Date(record.expirationDate).getTime()) return 'expired';
  const remaining =
    record.__remaining != null
      ? record.__remaining
      : Math.max(0, (Number(record.qty) || 0) - (Number(record.usedCount) || 0));
  if (remaining <= 0) return 'exhausted';
  return 'active';
}

function getStatusColor(status) {
  const colors = {
    active: 'green',
    scheduled: 'cyan',
    expired: 'volcano',
    exhausted: 'default',
  };
  return colors[status] || 'geekblue';
}

const couponsModuleService = { getDiscountTypes, getDerivedStatus, getStatusColor };
export default couponsModuleService;
